import OperationalInsights from '@/Components/OperationalInsightsCharts';

export default function OperationalInsightsPage() {
    return (
        <div>
            <div className="w-full flex flex-col gap-6 px-5 pb-4">
                <OperationalInsights />
            </div>
        </div>
    );
}
